import {
    HomeView,
    LoginView
} from '../views';

export const PublicRoutes = [
  {
    path: "/",
    component: HomeView,
    title: "Home",
    exact: true,
    showMenu: true
  },
  {
    path: "/login",
    component: LoginView,
    title: "Login",
    exact: true,
    showMenu: false
  }
];
